// modelCatalogFallback.json is a generated static snapshot of the backend's
// enabled models (source of truth: qualitycompute/model_catalog*.py).
// Regenerate with:
//   py -3 export_frontend_model_catalog.py
// from qualitycompute/. Do not hand-edit the JSON.
import fallbackModels from './modelCatalogFallback.json';


export const FALLBACK_MODEL_CATALOG = fallbackModels;


export function getBundledModelCatalog() {
  return FALLBACK_MODEL_CATALOG;
}


function warnAndReturnFallback(reason) {
  console.warn(
    `Model catalog: using bundled fallback snapshot (${reason}). ` +
      'This snapshot may be stale relative to the backend catalog.'
  );
  return FALLBACK_MODEL_CATALOG;
}


export async function fetchModelCatalog() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  if (!baseUrl) {
    return warnAndReturnFallback('REACT_APP_API_BASE_URL is not set');
  }

  try {
    const response = await fetch(`${baseUrl}/api/models`);
    if (!response.ok) {
      throw new Error(`Model catalog request failed with ${response.status}`);
    }
    const data = await response.json();
    if (!data || !Array.isArray(data.models)) {
      throw new Error('Model catalog response was missing models');
    }
    return data.models.filter((model) => model.enabled !== false);
  } catch (error) {
    return warnAndReturnFallback(error && error.message ? error.message : String(error));
  }
}
